
export const DashboardPage = Object.freeze({
    DASHBOARD: 0,
    REPORTS: 1,
    ENVIRONMENT: 2,
    CASHIERS: 3,
    CASH_IN: 4,
    INVENTORIES: 5,
    MESSAGES: 6,
    MAP: 7,
    COMPARISONS: 8,
    OPERATIONS: 9,
    DISTRIBUTIONS: 10,
    ACCOUNT: 11,
    SETTINGS: 12,
    ADMINISTRATION: 13,
    ACTIVATIONS: 14,
    OVERVIEW: 15,
    FORECASTS: 16,
    DIAGNOSTIC: 17,
    LICENSES_ASSIGNMENT: 18,
    LICENSES_HISTORY: 19,
    MONITORING: 20,
    HARDWARE_HISTORY: 23
});

export const DASHBOARD_PAGE_CONFIG = Object.freeze({
    [DashboardPage.DASHBOARD]: {
        titleKey: "Dashboard",
        screenName: "Dashboard"
    },
    [DashboardPage.REPORTS]: {
        titleKey: "Reports",
        screenName: "Reports"
    },
    [DashboardPage.ENVIRONMENT]: {
        titleKey: "Environment",
        screenName: "Environment"
    },
    [DashboardPage.CASHIERS]: {
        titleKey: "Cashiers",
        screenName: "Cashiers"
    },
    [DashboardPage.CASH_IN]: {
        titleKey: "Cash in",
        screenName: "Cash in"
    },
    [DashboardPage.INVENTORIES]: {
        titleKey: "Inventories",
        reportTitleKey: "Inventory",
        screenName: "Inventories"
    },
    [DashboardPage.MESSAGES]: {
        titleKey: "Messages",
        screenName: "Messages"
    },
    [DashboardPage.MAP]: {
        titleKey: "Map",
        screenName: "Map"
    },
    [DashboardPage.COMPARISONS]: {
        titleKey: "Comparisons",
        screenName: "Comparisons"
    },
    [DashboardPage.OPERATIONS]: {
        titleKey: "Operations",
        screenName: "Operations"
    },
    [DashboardPage.DISTRIBUTIONS]: {
        titleKey: "Distributions",
        screenName: "Distributions"
    },
    [DashboardPage.ACCOUNT]: {
        titleKey: "Account",
        screenName: "Account"
    },
    [DashboardPage.SETTINGS]: {
        titleKey: "Setting",
        screenName: "Setting"
    },
    [DashboardPage.ADMINISTRATION]: {
        titleKey: "Administration",
        screenName: "Administration"
    },
    [DashboardPage.ACTIVATIONS]: {
        titleKey: "Activations",
        screenName: "Activations"
    },
    [DashboardPage.OVERVIEW]: {
        titleKey: "Overview",
        screenName: "Overview"
    },
    [DashboardPage.FORECASTS]: {
        titleKey: "Forecasts",
        screenName: "Forecasts"
    },
    [DashboardPage.DIAGNOSTIC]: {
        titleKey: "Diagnostic",
        screenName: "Diagnostic"
    },
    [DashboardPage.LICENSES_ASSIGNMENT]: {
        titleKey: "Licenses assignment",
        screenName: "Licenses assignment"
    },
    [DashboardPage.LICENSES_HISTORY]: {
        titleKey: "Licenses history",
        screenName: "Licenses history"
    },
    [DashboardPage.MONITORING]: {
        titleKey: "Monitoring",
        screenName: "Monitoring"
    },
    [DashboardPage.HARDWARE_HISTORY]: {
        titleKey: "Hardware history",
        screenName: "Hardware history"
    }
});

export const getDashboardPageTitleKey = (page, forReports = false) => {
    const config = DASHBOARD_PAGE_CONFIG[page];
    if (!config) {
        return "";
    }

    if (forReports && config.reportTitleKey) {
        return config.reportTitleKey;
    }

    return config.titleKey;
};

export const getDashboardScreenName = (page) => {
    const config = DASHBOARD_PAGE_CONFIG[page];
    return config?.screenName || `Unknown ${page}`;
};